import { useState, useEffect } from 'react';

export function TypingDots({ visible = true }) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!visible) { setShow(false); return; }
    const t = setTimeout(() => setShow(true), 500);
    return () => clearTimeout(t);
  }, [visible]);
  if (!show) return null;
  return <span className="typing-dots" data-testid="typing-dots" aria-label="typing">···</span>;
}
